import initI18n from './i18n';
import { seedUviloVocabulary } from '@erikdakoda/memory/shared/seedUviloVocabulary';

export default function init() {
  initI18n();
  // Every app seeds all vocabularies (relaxed cross-app reads/display).
  seedUviloVocabulary();
}
